import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import CommandHistory from '../../CommandsHistory/CommandHistory';
import { CommandHistoryDropDownFilterCell } from '../../CommandsHistory/CommandHistoryDropDownFilterCell';

const useStyles = makeStyles((theme: Theme) => createStyles({}));

export const CommandRequestHistory = () => {
  const classes = useStyles();
  const dispatch: Dispatch<any> = useDispatch();

  return (
    <div>
      <CommandHistory
        title="CONFIG_CHANGE_REQUEST_HISTORY"
        commandName={'ApplyConfig'}
        dropDownFilterCell={CommandHistoryDropDownFilterCell}
      />
    </div>
  );
};
